var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.statusData.dashboardType == "graph_department"
    ? _c(
        "div",
        { class: "graphStat-wrapper-" + _vm.statusData.dashboardType },
        [
          _c("div", [
            _c(
              "h2",
              {
                staticClass: "d-inline-block",
                staticStyle: { position: "relative" }
              },
              [_vm._v("By Department")]
            ),
            _vm._v(" "),
            _c("div", {
              staticClass: "department-stats-bar",
              style: { backgroundColor: _vm.statusColor }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "stats-trending" })
          ]),
          _vm._v(" "),
          _vm.loadData.allDeliverables == ""
            ? _c(
                "div",
                {
                  staticStyle: {
                    position: "relative",
                    height: "100%",
                    width: "100%"
                  }
                },
                [
                  _vm._v(
                    "\n        Media Calls by Department will be displayed.\n    "
                  )
                ]
              )
            : _c(
                "div",
                {
                  staticStyle: {
                    position: "relative",
                    height: "100%",
                    width: "100%"
                  }
                },
                [
                  _c("Bar", {
                    key: "barchart" + _vm.statKey,
                    attrs: {
                      "chart-options": _vm.chartOptions,
                      "chart-data": _vm.chartData,
                      "chart-id": _vm.chartId,
                      "dataset-id-key": _vm.datasetIdKey,
                      plugins: _vm.plugins,
                      "css-classes": _vm.cssClasses,
                      styles: _vm.styles,
                      width: _vm.width
                    }
                  })
                ],
                1
              )
        ]
      )
    : _c(
        "div",
        { class: "row graphStat-wrapper-" + _vm.statusData.dashboardType },
        [
          _c("div", { staticClass: " stats-border breakpoint__fix" }, [
            _c("div", { staticClass: "dashboard-stats" }, [
              _vm._m(0),
              _vm._v(" "),
              _vm.loadData.allDeliverables == ""
                ? _c("span", { staticClass: "stats-trending-wrap" }, [
                    _c("span", { staticClass: "stats-trending" }, [
                      _vm._v(
                        "\n                    Trending tags will be displayed.\n                   "
                      )
                    ]),
                    _vm._v(" "),
                    false
                      ? _c("div", {
                          staticClass: "trending-stats-bar",
                          style: { backgroundColor: _vm.statusColor }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    false
                      ? _c("span", { staticClass: "trending-stats-bar-text" })
                      : _vm._e()
                  ])
                : _c(
                    "span",
                    {
                      key: "stat" + _vm.statKey,
                      staticClass: "stats-trending-wrap"
                    },
                    [
                      _vm._l(_vm.trendingList.slice(0, 3), function(
                        item,
                        index
                      ) {
                        return _c(
                          "span",
                          { key: index, staticClass: "stats-trending" },
                          [
                            index > 0 && _vm.trendingList.length > 1
                              ? [_vm._v(", ")]
                              : _vm._e(),
                            _vm._v(_vm._s(item.name))
                          ],
                          2
                        )
                      }),
                      _vm._v(" "),
                      false
                        ? _c("div", {
                            staticClass: "trending-stats-bar",
                            style: { backgroundColor: _vm.statusColor }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      false
                        ? _c("span", { staticClass: "trending-stats-bar-text" })
                        : _vm._e()
                    ],
                    2
                  )
            ])
          ])
        ]
      )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stats-left-name-wrap" }, [
      _c("span", { staticClass: "stats-left-name" }, [_vm._v(" Trending")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }